import { get } from "@/utils/get";

import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";

function InputText({ error, onChange, ...props }) {
  return (
    <TextField
      {...props}
      fullWidth
      onChange={(e) => onChange?.(props.id, e.target.value)}
      placeholder={props.label}
      value={props.value ?? ""}
      error={!!get(props.name ?? props.id, error)}
      helperText={get(props.name ?? props.id, error)?.[0] || props.helperText}
    />
  );
}

InputText.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.object,
  helperText: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default InputText;
